define('rebrush/components/blocks/gigaset/shipping/sales/order/shipment/return',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    $,
    Component,
    BEM
) {
    const BLOCK_NAME = 'gigaset-shipping-sales-order-shipment-return';

    function GigasetShippingSalesOrderShipmentReturn(block) {
        this.block = BEM.block(block);
        this.form = this.block.find('form');
        this.init();
    }

    GigasetShippingSalesOrderShipmentReturn.prototype = {
        init: function() {
            this.block.on('click', 'button[value^="view/"]', (e) => {
                e.preventDefault();

                const button = $(e.currentTarget);
                const intentInput = $(`<input type="hidden" name="${button.attr('name')}" value="${button.attr('value')}" />"`);

                const popup = window.open('', 'returnLabelPopup', 'width=600,height=400');

                this.form.append(intentInput);

                this.form.attr('target', 'returnLabelPopup');
                this.form.submit();

                this.form.attr('target', null);
                intentInput.remove();

                // const button = $(e.target);
                //
                // // Create a new window
                //
                //
                // // Create a form in the popup
                // const popupForm = document.createElement('form');
                // popupForm.method = 'POST';
                // popupForm.action = this.form.attr('action');
                //
                // // Copy all form inputs to the popup form
                // const originalForm = this.form.get(0);
                // const inputs = originalForm.querySelectorAll('input, select, textarea');
                // inputs.forEach(input => {
                //     const clonedInput = input.cloneNode(true);
                //     popupForm.appendChild(clonedInput);
                // });
                //
                // $(`<input type="hidden" name="${button.attr('name')}" value="${button.attr('name')}" />`).appendTo(popupForm);
                //
                // // Add the form to popup and submit it
                // popup.document.body.appendChild(popupForm);
                // // popupForm.submit();
            });
        }
    };

    return Component.create({
        $init: function() {
            BEM.block(BLOCK_NAME).each(function() {
                new GigasetShippingSalesOrderShipmentReturn(this);
            });
        }
    });
});
